import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericDirective {
  @Input() allowPaste: boolean = false;
  constructor(private el: ElementRef<HTMLInputElement>) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    if (allowedKeys.includes(event.key)) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.allowPaste) {
      event.preventDefault();
      return;
    }

    const pastedInput = event.clipboardData?.getData('text') ?? '';
    // Strip non-digit characters
    const cleaned = pastedInput.replace(/\D+/g, '');

    // Insert cleaned value at cursor position
    event.preventDefault();
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    input.value = input.value.slice(0, start) + cleaned + input.value.slice(end);

    // Move cursor to end of pasted content
    const cursorPos = start + cleaned.length;
    input.setSelectionRange(cursorPos, cursorPos);

    // Dispatch input event so Angular updates form control
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }



  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const cleaned = input.value.replace(/\D+/g, ''); // remove all non-digits
    if (input.value !== cleaned) {
      input.value = cleaned;
      // re-dispatch so Angular form control updates properly
      const ev = new Event('input', { bubbles: true });
      input.dispatchEvent(ev);
    }
  }
}
